import { Box, BoxProps, InternalStandardProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect, useMemo } from "react";
import {
    useGlobalBlackRecommendations,
    useGlobalRecommendations,
    useOpenAutoPopup,
    useRecommendations,
} from "JS/React/Hooks/Recommendations";
import { AppBackdropProgress } from "JS/React/Components/Progress/AppBackdropProgress";
import { useOpenConsentForm } from "../Hooks/ConsentForm";

export interface RecommendationsManagerProps
    extends InternalStandardProps<BoxProps> {
    children: React.ReactNode;
}

const StyledBox = styled(Box)({});

export const RecommendationsManager = (props: RecommendationsManagerProps) => {
    const { className, children, ...rest } = props;

    const { recommendationsLoading, open } = useRecommendationVariables();
    useFirstStart(!open);

    const loading = recommendationsLoading;

    return (
        <StyledBox className={className} {...rest}>
            {loading ? (
                <AppBackdropProgress
                    open
                    backdropText="Loading Recommendations"
                />
            ) : (
                <>{children}</>
            )}
        </StyledBox>
    );
};

export const useRecommendationVariables = () => {
    const { recommendationState } = useGlobalRecommendations();

    const skipRecommendations = recommendationState?.recommendations != null;

    const { loading: recommendationsLoading } = useRecommendations(true);

    const open = useMemo(() => {
        return skipRecommendations || !recommendationsLoading;
    }, [skipRecommendations, recommendationsLoading]);
    return {
        recommendationsLoading,
        open,
    };
};

const useFirstStart = (skip: boolean = false) => {
    const { blackRecommendationState, setGlobalBlackRecommendations } =
        useGlobalBlackRecommendations();
    const { openPopup } = useOpenAutoPopup();
    const { openForm } = useOpenConsentForm();
    useEffect(() => {
        if (blackRecommendationState?.firstStart) {
            /**Anything here will run on application restart */
            setGlobalBlackRecommendations({ firstStart: false });
            openForm();
            if (!skip) openPopup();
        }
    }, [blackRecommendationState?.firstStart, skip]);
};
